import React, { useEffect } from "react";
import AnketOylamasi from "./AnketOylamasi";
import { useDispatch, useSelector } from "react-redux";
import { fetchFeedbacksAsync } from "../../redux/actions/completeVotingAction";
import { getProfileImage } from "../../redux/actions/imgAction";

const GeriBildirimler = ({ user }) => {
  const dispatch = useDispatch();
  const { feedbacks, feedbacksLoading, feedbacksError } = useSelector(
    (state) => state.completeVoting
  );
  const { imageData } = useSelector((state) => state.img);

  useEffect(() => {
    dispatch(fetchFeedbacksAsync());
  }, [dispatch]);

  useEffect(() => {
    if (feedbacks?.data) {
      // Her bir feedback için profil resmini çek
      feedbacks.data.forEach((feedback) => {
        if (feedback.evaluatorId) {
          dispatch(getProfileImage(feedback.evaluatorId));
        }
      });
    }
  }, [dispatch, feedbacks]);

  if (feedbacksLoading)
    return (
      <div className="mt-4 text-grayy text-sm">
        Geri bildirimler yükleniyor...
      </div>
    );
  if (feedbacksError) return <div>Hata: {feedbacksError}</div>;

  const getImageSrc = (evaluatorId) => {
    if (
      imageData[evaluatorId]?.data?.length > 0 &&
      imageData[evaluatorId].data[0].content
    ) {
      return `data:image/jpeg;base64,${imageData[evaluatorId].data[0].content}`;
    }
    return "/defaultPerson.svg";
  };

  return (
    <div className="detay-container">
      <p className="text-dark text-lg tracking-wide font-medium">
        Geribildirimler
      </p>

      <AnketOylamasi user={user} />
      <div className="yorumlar flex flex-col gap-6 pt-4">
        {!feedbacks?.data?.length ? (
          <div className="text-grayy text-base text-center py-4">
            Henüz geribildirim almadınız.
          </div>
        ) : (
          feedbacks.data.map((item, index) => (
            <div key={index} className="yorum flex flex-col gap-4 pt-4">
              <div className="yorum-top flex flex-col gap-3 sm:flex-row justify-between items-center">
                <div className="yazan flex gap-4 items-center p-4 h-[48px] w-full ">
                  <div>
                    <img
                      src={getImageSrc(item.evaluatorId)}
                      alt="person"
                      className="size-[48px] rounded-full object-cover"
                    />
                  </div>
                  <div className="flex flex-col gap-2">
                    <p className="text-dark text-base font-semibold">
                      {item.evaluatorUser.name}
                    </p>
                    <p className="text-sm text-grayy whitespace-nowrap">
                      {item.evaluatorUser.position.name}
                    </p>
                  </div>
                </div>
                <div className="tarih text-xs hidden sm:block text-grayy">
                  {new Date(item.updatedAt).toLocaleDateString("tr-TR")}
                </div>
              </div>
              <div className="yorum-text bg-lightGray text-sm leading-5 font-normal p-4 rounded-lg text-grayy w-full h-auto">
                <p>{item.feedback}</p>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default React.memo(GeriBildirimler);
